import ZipCodeInput from '@carvana/showroom-forms/Input/ZipCode';
import { PrimaryButton } from '@/common/Button';
import LocationMarkerIcon from './LocationMarkerIcon';
import {
  MapLegendSearchAreaContainer,
  MapLegendSearchAreaHeader,
  MapLegendSearchAreaHeaderText,
  MapLegendSearchAreaInputWrapper
} from './MapLegend.styles';

type OwnProps = {
  onSubmit: () => void;
  onChange: (searchTerm: string) => void;
  searchTerm: string;
};

export default function MapFinderSearchArea({
  onSubmit,
  onChange,
  searchTerm
}: OwnProps) {
  return (
    <MapLegendSearchAreaContainer>
      <MapLegendSearchAreaHeader>
        <div>
          <LocationMarkerIcon />
        </div>
        <MapLegendSearchAreaHeaderText>
          FIND A VENDING MACHINE NEAR YOU
        </MapLegendSearchAreaHeaderText>
      </MapLegendSearchAreaHeader>

      <MapLegendSearchAreaInputWrapper>
        <form
          className="flex gap-8"
          onSubmit={ev => {
            ev.preventDefault();

            onSubmit();
          }}
        >
          <ZipCodeInput
            onChange={ev => onChange(ev.currentTarget.value)}
            value={searchTerm}
            id="zipcode-map"
          />
          <PrimaryButton
            className="min-w-[unset]!"
            size="small"
            type="submit"
            data-analytics-id="Zip Code Search"
            data-testid="zip-code-search"
          >
            GO
          </PrimaryButton>
        </form>
      </MapLegendSearchAreaInputWrapper>
    </MapLegendSearchAreaContainer>
  );
}
